require('./runtime');
"use strict";
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[2184],{

/***/ 30108:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _baUiCarbon = __webpack_require__(6536);
var _lodash = __webpack_require__(46517);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-common
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

/* eslint-disable jsx-a11y/click-events-have-key-events */

const {
  BaPropTypes
} = _utils.propsUtils;
class ExpandableTile extends _react.Component {
  render() {
    const {
      maxWidth,
      label,
      children,
      labelStyle,
      labelClassName,
      initialExpanded,
      expanded,
      onChange,
      ...others
    } = this.props;
    const mappedProps = {
      expanded: expanded != null ? expanded : initialExpanded,
      handleClick: onChange
    };
    const passThroughProps = (0, _lodash.omit)(others, 'pinMode');
    return /*#__PURE__*/_react.default.createElement(_baUiCarbon.ExpandableTile, (0, _extends2.default)({
      maxWidth: maxWidth
    }, mappedProps, passThroughProps), /*#__PURE__*/_react.default.createElement(_baUiCarbon.TileAboveTheFoldContent, null, /*#__PURE__*/_react.default.createElement("div", {
      className: labelClassName,
      style: labelStyle
    }, label)), /*#__PURE__*/_react.default.createElement(_baUiCarbon.TileBelowTheFoldContent, null, /*#__PURE__*/_react.default.createElement("div", {
      onClick: e => e.stopPropagation()
    }, children)));
  }
}
exports["default"] = ExpandableTile;
(0, _defineProperty2.default)(ExpandableTile, "propTypes", {
  /** Data passed to the above the fold content
   *  Legacy tooltip prop will map to TileAboveTheFoldContent
   */
  label: _propTypes.default.node,
  /**
   * Carbon The child nodes.
   * Or legacy tooltip child nodes will map to TileBelowTheFoldContent
   * Data passed to the below the fold content
   */
  children: _propTypes.default.node,
  /**
   * The CSS class names.
   */
  className: _propTypes.default.string,
  /**
   * Legacy toolkit prop will map to expanded
   * Specifies whether the tile is initially expanded or not */
  initialExpanded: _propTypes.default.bool,
  /**
   * `true` if the tile is expanded.
   */
  expanded: _propTypes.default.bool,
  /**
   * optional handler to decide whether to ignore a click. returns false if click should be ignored
   */
  onBeforeClick: _propTypes.default.func,
  /**
   * The `tabindex` attribute.
   */
  tabIndex: _propTypes.default.number,
  /**
   * The description of the "collapsed" icon that can be read by screen readers.
   */
  tileCollapsedIconText: _propTypes.default.string,
  /**
   * The description of the "expanded" icon that can be read by screen readers.
   */
  tileExpandedIconText: _propTypes.default.string,
  /**
   * An ID that can be provided to aria-labelledby
   */
  id: _propTypes.default.string,
  /**
   * `true` to use the light version. For use on $ui-01 backgrounds only.
   * Don't use this to make tile background color same as container background color.
   */
  light: _propTypes.default.bool,
  /** Legacy toolkit prop
   * Specifies the maximum width of the ExpandableTile
   */
  maxWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /** Legacty toolkit prop, will pass to TileAboveTheFoldContent
   * Styles for the TileAboveTheFoldContent
   */
  labelStyle: _propTypes.default.object,
  /**
   * Legacty toolkit prop, will pass to TileAboveTheFoldContent
   * The CSS class names for the TileAboveTheFoldContent
   */
  labelClassName: _propTypes.default.string,
  /** Legacty toolkit prop, will pass to CarbonExpandableTile
   * Styles for the CarbonExpandableTile
   */
  style: _propTypes.default.object,
  /**
   * Legacy toolkit prop will map to handleClick
   * Callback function when the item is toggled
   */
  onChange: _propTypes.default.func,
  // deprecated prop
  // eslint-disable-next-line react/no-unused-prop-types
  pinMode: BaPropTypes.deprecatedByCarbon(_baUiCarbon.ExpandableTile)
});
(0, _defineProperty2.default)(ExpandableTile, "defaultProps", {
  maxWidth: 'max-content',
  labelClassName: ''
});

/***/ }),

/***/ 91726:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _ExpandableTile = _interopRequireDefault(__webpack_require__(30108));
exports["default"] = _ExpandableTile.default;
exports.ExpandableTile = _ExpandableTile.default;

/***/ }),

/***/ 6536:
/***/ ((module) => {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 68779:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 46517:
/***/ ((module) => {

module.exports = require("lodash");

/***/ }),

/***/ 580:
/***/ ((module) => {

module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

module.exports = require("react");

/***/ }),

/***/ 78815:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(91726));
/******/ return __webpack_exports__;
/******/ }
]);
});